"use strict";

exports.__esModule = true;
exports.AgendaName = AgendaName;
var _react = _interopRequireDefault(require("react"));
var _Core = require("../../Core");
var _common = require("../../Device/common");
var _DeviceListContext = require("../../Device/DeviceListContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function AgendaName(_ref) {
  var agenda = _ref.agenda;
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var devices = _react["default"].useContext(_DeviceListContext.DeviceListContext);
  if (agenda.devices.length === 0) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, translate("AgendaName.plantAgenda", "Plant Agenda"));
  }
  var firstDevice = (0, _common.getDevice)(devices, agenda.devices[0]);
  var label = firstDevice ? firstDevice.name : agenda.devices[0];
  if (agenda.devices.length === 1) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, label);
  }
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, agenda.devices[0], " (+", agenda.devices.length - 1, " ", translate("AgendaName.more", "more"), ")");
}